import {
  getReflectionsDraftUrl,
  getReflectionsUrl,
  getReflectionsVersionUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class ReflectionService {
  static getReflections = () => {
    return getRequest(getReflectionsUrl()).then((reflections) => {
      return reflections;
    });
  };

  static getReflectionsForContext = (contextId, userId) => {
    const params = { userId: userId };
    return getRequest(getReflectionsUrl() + "/" + contextId, params);
  };

  static createReflectionDraft = ({
    reflectionId,
    sectionId,
    templateId,
    contextId,
    author,
    userId,
    htmlContent,
  }) => {
    const params = {
      author: author,
      userId: userId,
      reflectionId: reflectionId,
      htmlContent: htmlContent,
    };
    if (sectionId) {
      params.sectionId = sectionId;
    }
    if (templateId) {
      params.templateId = templateId;
    }
    return postRequest(getReflectionsDraftUrl() + "/" + contextId, params);
  };

  static getReflectionVersionHistory = (contextId, reflectionId, sectionId) => {
    const params = { reflectionId: reflectionId };
    if (sectionId) {
      params.sectionId = sectionId;
    }
    return getRequest(getReflectionsVersionUrl() + "/" + contextId, params);
  };

  static addReflection = (termId, text, author, cycle, course) => {
    const param = {
      termId: termId,
      text: text,
      author: author,
      cycle: cycle,
      course: course,
    };
    return postRequest(getReflectionsUrl(), param);
  };

  static addReflectionForContext = ({
    reflectionId,
    sectionId,
    templateId,
    contextId,
    author,
    actions = [],
    userId = null,
    htmlContent,
  }) => {
    const param = {
      reflectionId: reflectionId,
      author: author,
      actions: actions,
      htmlContent: htmlContent,
    };
    if (userId) {
      param.userId = userId;
    }
    if (sectionId) {
      param.sectionId = sectionId;
    }
    if (templateId) {
      param.templateId = templateId;
    }

    return postRequest(getReflectionsUrl() + "/" + contextId, param);
  };

  static deleteReflection = ({
    contextId,
    reflectionId,
    sectionId,
    userId = "",
  }) => {
    const params = { reflectionId: reflectionId, userId: userId };
    if (sectionId) {
      params.sectionId = sectionId;
    }
    return deleteRequest(getReflectionsUrl() + "/delete/" + contextId, params);
  };

  static updateReflection = (reflection) => {
    return putRequest(
      getReflectionsUrl() + "/update/" + reflection.id,
      reflection
    );
  };

  static getCourseReflectionsByOfferingId = (offeringId) => {
    return getRequest(getReflectionsUrl() + "/course/" + offeringId);
  };
}
